module.exports = __webpack_public_path__ + "img/SLT_0746-Bearbeitet.a9608b62.jpg";